import React from "react";
import { FileText, Users, Clock3, CheckCircle2, ArrowUpRight, ArrowRight, MapPin, CalendarDays, } from "lucide-react";
import "../styles/Dashboard.css";
const stats = [
    {
        title: "Total Quotes",
        value: "245",
        change: "+12.5%",
        icon: FileText,
    },
    {
        title: "New Quotes",
        value: "42",
        change: "+8.2%",
        icon: FileText,
    },
    {
        title: "Pending",
        value: "18",
        change: "+4.6%",
        icon: Clock3,
    },
    {
        title: "Completed",
        value: "96",
        change: "+15.4%",
        icon: CheckCircle2,
    },
    {
        title: "Customers",
        value: "89",
        change: "+9.1%",
        icon: Users,
    },
];

const recentQuotes = [
    {
        id: "Q000245",
        name: "Kumar",
        pickup: "Erode",
        delivery: "Chennai",
        date: "10 Oct 2026",
        status: "NEW",
    },
    {
        id: "Q000244",
        name: "Rajesh",
        pickup: "Coimbatore",
        delivery: "Bangalore",
        date: "12 Oct 2026",
        status: "CONTACTED",
    },
    {
        id: "Q000243",
        name: "Prakash",
        pickup: "Chennai",
        delivery: "Madurai",
        date: "14 Oct 2026",
        status: "QUOTATION_SENT",
    },
    {
        id: "Q000242",
        name: "Suresh",
        pickup: "Salem",
        delivery: "Erode",
        date: "15 Oct 2026",
        status: "IN_PROGRESS",
    },
    {
        id: "Q000241",
        name: "Arun",
        pickup: "Tiruppur",
        delivery: "Chennai",
        date: "18 Oct 2026",
        status: "COMPLETED",
    },
];

const getStatusClass = (status) => {
    switch (status) {
        case "NEW":
            return "status-new";

        case "CONTACTED":
            return "status-contacted";

        case "QUOTATION_SENT":
            return "status-quotation";

        case "IN_PROGRESS":
            return "status-progress";

        case "COMPLETED":
            return "status-completed";

        default:
            return "";
    }
};

export default function Dashboard() {
    return (
        <div className="dashboard-page">
            <div className="dashboard-page-header">
                <div>
                    <h1>Dashboard</h1>
                    <p>Overview of your moving enquiries and operations.</p>
                </div>
                <button className="dashboard-date-btn"><CalendarDays size={17} />October 2026</button>
            </div>
            <div className="dashboard-stats">
                {stats.map((item) => {
                    const Icon = item.icon;
                    return (
                        <div className="dashboard-stat-card" key={item.title}>
                            <div className="stat-top">
                                <div className="stat-icon"><Icon size={20} /></div>
                                <span className="stat-change"><ArrowUpRight size={14} />{item.change}</span>
                            </div>
                            <div className="stat-value">{item.value}</div>
                            <div className="stat-title">{item.title}</div>
                        </div>
                    );
                })}
            </div>
            <div className="dashboard-main-grid">
                <div className="dashboard-card quote-overview">
                    <div className="dashboard-card-header">
                        <div>
                            <h3>Quote Overview</h3>
                            <p>Monthly quote requests</p>
                        </div>
                    </div>
                    <div className="chart-container">
                        <div className="chart-y-axis">
                            <span>100</span>
                            <span>80</span>
                            <span>60</span>
                            <span>40</span>
                            <span>20</span>
                            <span>0</span>
                        </div>
                        <div className="chart-area">
                            <div className="chart-lines">
                                <span></span>
                                <span></span>
                                <span></span>
                                <span></span>
                                <span></span>
                                <span></span>
                            </div>
                            <div className="chart-bars">
                                <div className="chart-bar">
                                    <span style={{ height: "45%" }}></span>
                                    <small>Jan</small>
                                </div>
                                <div className="chart-bar">
                                    <span style={{ height: "58%" }}></span>
                                    <small>Feb</small>
                                </div>
                                <div className="chart-bar">
                                    <span style={{ height: "42%" }}></span>
                                    <small>Mar</small>
                                </div>
                                <div className="chart-bar">
                                    <span style={{ height: "68%" }}></span>
                                    <small>Apr</small>
                                </div>
                                <div className="chart-bar">
                                    <span style={{ height: "55%" }}></span>
                                    <small>May</small>
                                </div>
                                <div className="chart-bar">
                                    <span style={{ height: "75%" }}></span>
                                    <small>Jun</small>
                                </div>
                                <div className="chart-bar">
                                    <span style={{ height: "62%" }}></span>
                                    <small>Jul</small>
                                </div>
                                <div className="chart-bar">
                                    <span style={{ height: "82%" }}></span>
                                    <small>Aug</small>
                                </div>
                                <div className="chart-bar">
                                    <span style={{ height: "72%" }}></span>
                                    <small>Sep</small>
                                </div>
                                <div className="chart-bar">
                                    <span style={{ height: "88%" }}></span>
                                    <small>Oct</small>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="dashboard-card recent-quotes">
                    <div className="dashboard-card-header">
                        <div>
                            <h3>Recent Quotes</h3>
                            <p>Latest quote requests</p>
                        </div>
                        <button className="view-all-btn">
                            View All
                            <ArrowRight size={15} />
                        </button>
                    </div>
                    <div className="recent-quote-list">
                        {recentQuotes.map((quote) => (
                            <div className="recent-quote-item" key={quote.id}>
                                <div className="quote-info">
                                    <div className="quote-id">{quote.id}</div>
                                    <strong>{quote.name}</strong>
                                    <div className="quote-route">
                                        <MapPin size={13} />
                                        {quote.pickup}
                                        <span>→</span>
                                        {quote.delivery}
                                    </div>
                                </div>
                                <div className="quote-right">
                                    <span className={`quote-status ${getStatusClass(quote.status)}`}>{quote.status.replace("_", " ")}</span>
                                    <small>{quote.date}</small>
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
            </div>            
            <div className="dashboard-bottom-grid">
                <div className="dashboard-card">
                    <div className="dashboard-card-header">
                        <div>
                            <h3>Quote Status</h3>
                            <p>Current quotation status</p>
                       </div>
                    </div>
                    <div className="status-summary">
                        <div>
                            <span className="status-dot dot-new"></span>
                            <label>New</label>
                            <strong>42</strong>
                        </div>
                        <div>
                            <span className="status-dot dot-contacted"></span>
                            <label>Contacted</label>
                            <strong>27</strong>
                        </div>
                        <div>
                            <span className="status-dot dot-progress"></span>
                            <label>In Progress</label>
                            <strong>18</strong>
                        </div>
                        <div>
                            <span className="status-dot dot-completed"></span>
                            <label>Completed</label>
                            <strong>96</strong>
                        </div>
                    </div>
                </div>
                <div className="dashboard-card">
                    <div className="dashboard-card-header">
                        <div>
                            <h3>Quick Summary</h3>
                            <p>Today's activity</p>
                        </div>
                    </div>
                    <div className="quick-summary">
                        <div>
                            <span>Today's Quotes</span>
                            <strong>12</strong>
                        </div>
                        <div>
                            <span>New Customers</span>
                            <strong>7</strong>
                        </div>
                        <div>
                            <span>Quotations Sent</span>
                            <strong>5</strong>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}